if(BSS_B2B) {
  setTimeout(() => {
    if (!BSS_B2B.page.isProductPage()) {
      const targetQuickview = document.querySelectorAll(
        "quick-view-drawer details"
      );
      targetQuickview.forEach((item) => {
        const mutationObserver = new MutationObserver((recordList, observe) => {
          setTimeout(() => {
            BSS_B2B.cp.changeProductPrice(
              JSON.parse($("#bss-b2b-store-data").html()),
              false,
              false,
              false
            );
          }, 2000);
        });
        mutationObserver.observe(item, { attributes: true });
      });
    }
  }, 1000);

  if(window.location.pathname.includes("/cart")) {
    setTimeout(() =>{
      function handleButtonClick(e) {
        e.preventDefault();
        const $button = $(this);
        let oldText = $(this).text();
        $button.css({'pointer-events': 'none', 'opacity': '0.6'});
        $button.text("Loading ...");
        setTimeout(() =>{
          $button.css({'pointer-events': 'unset', 'opacity': '1'})
            $button.text(oldText);
        }, 2000);
      }
     
     $(document).on('click dblclick', '.cart__checkout-button', handleButtonClick);
    }, 500)
  }

}